<div class="h-100 px-0 px-lg-2 px-xl-5 py-2">
    <div style="text-align: center;">
        <!-- <h6 class="m-0">{{title[status]}}</h6> -->
    </div>
    
    <div class="m-3 p-3" *ngIf="notificationData.length == 0">
        <div class="mat-elevation-z4"
            style="border-radius: 10px; text-align: center; height: 40px; align-content: center;color: #205567;font-weight: 500;">
            No Notifications Found.
        </div>
    </div>



    <div class="p-3 d-flex flex-column gap-3"
        style="border-radius: 10px;backdrop-filter: blur(10px);background: rgba(255,255,255,0.8);">
        <div class="table-responsive">
            <table class="table rounded-3 m-0">
                <thead>
                    <tr>
                        <th style="background: #C5E2DA;color: #205567;">Task Id</th>
                        <th style="background: #C5E2DA;color: #205567;">Case/Patient</th>
                        <th style="background: #C5E2DA;color: #205567;">Type</th>
                        <th style="background: #C5E2DA;color: #205567;">Notification</th>
                        <th style="background: #C5E2DA;color: #205567;">Created by</th>
                        <th style="background: #C5E2DA;color: #205567;">Created Time</th>
                        <!-- <th *ngIf="dataService.role != 'doctor' || status == 'complete'">Amount</th>
                        <th>Design Level</th>
                        <th>Delivery Time</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let task of notificationData" [ngClass]="{'active-notification': task.active}">
                        <td style="color: #205567; font-weight: 500;"><a class="text-decoration-none"style="color: #205567;" href="javascript:void(0)" (click)="navigateToOrderDetails(task.taskId, task.type)">{{task.taskId}}</a></td>
                        <td style="color: #205567;">{{task.refNum}}</td>
                        <td style="color: #205567;">{{task.type}}</td>
                        <td style="color: #205567;">{{task.comments}}</td>
                        <td style="color: #205567;">{{task.crtBy}}</td>
                        <td style="color: #205567;">{{task.crtTm | date:'short'}}</td>
                        <!-- <td *ngIf="dataService.role != 'doctor' || status == 'complete'">{{task.amount.toFixed(2)}}</td>
                        <td>{{task.tier == 'ai' ? '' : task.tier}}</td>
                        <td>{{task.deliveryTime}} hrs</td> -->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>


  

</div>